import {
  FETCH_RENAME_THERMIT_UNIT_AREA_REQUEST,
  FETCH_RENAME_THERMIT_UNIT_AREA_SUCCESS,
  FETCH_RENAME_THERMIT_UNIT_AREA_FALUIRE,
} from './renameThermitUnitAreaTypes'

const initialState = {
  loading: false,
  isRenameThermitUnitAreaSuccess: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_RENAME_THERMIT_UNIT_AREA_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_RENAME_THERMIT_UNIT_AREA_SUCCESS : return {
      ...state,
      isRenameThermitUnitAreaSuccess: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_RENAME_THERMIT_UNIT_AREA_FALUIRE : return {
      ...state,
      loading: false,
      isRenameThermitUnitAreaSuccess: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
